import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { required, EspacioBlanco } from "@/commons/utils/Rules";
import 'element-ui/lib/theme-chalk/display.css';
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument";
import { getRelacionesLaborales, getEmpresasOferentes } from "@/routes/api/resources";
import { validateContact, validateNames } from "@/routes/api/resources";
import { isEmpty } from "@/commons/utils/functions";
export default {
  name: 'PzPersonForm1Vehiculo',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzIdentityDocument: PzIdentityDocument
  },
  mixins: [PzBaseForm1],
  data: function data() {
    var _this = this;
    var check_Fecha = function check_Fecha(rule, value, callback) {
      localStorage.setItem('isjubilado', true);
      if (_this.formulario1.relacion_laboral_id != 4) localStorage.setItem('isjubilado', false);
      if (_this.formulario1.relacion_laboral_id != 4 && !value) {
        return callback(new Error(_this.$t('rules.incomplete')));
      }
      return callback();
    };
    var check_telefono = function check_telefono(rule, value, callback) {
      var regla = "^[+]?[0-9]{10}$";
      var pattern = new RegExp(regla.toString());
      if (!pattern.test(value)) {
        return callback(new Error(_this.$t('rules.phone_rule')));
      } else {
        _this.$store.dispatch('loader/up', {
          trigger: _this.$options.name
        });
        validateContact(null, _this.formulario1.telefono, _this.formulario1.identity.number).then(function (res) {
          if (res.data.phone_exists) {
            return callback(new Error(_this.$t('rules.phone_exists')));
          } else {
            return callback();
          }
        }).catch(function () {
          return callback(new Error(_this.$t('rules.phone_exists')));
        }).finally(function () {
          _this.$store.dispatch('loader/down', {
            trigger: _this.$options.name
          });
        });
      }
    };
    var check_name = function check_name(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('rules.name_required')));
      } else {
        _this.$store.dispatch('loader/up', {
          trigger: _this.$options.name
        });
        validateNames(1, _this.formulario1.nombres, _this.formulario1.identity.number).then(function (res) {
          if (!res.data.correct) {
            return callback(new Error(_this.$t('rules.name_rule')));
          } else {
            return callback();
          }
        }).catch(function () {
          return callback(new Error(_this.$t('rules.name_rule')));
        }).finally(function () {
          _this.$store.dispatch('loader/down', {
            trigger: _this.$options.name
          });
        });
      }
    };
    var check_lastname = function check_lastname(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('rules.lastname_required')));
      } else {
        _this.$store.dispatch('loader/up', {
          trigger: _this.$options.name
        });
        validateNames(2, _this.formulario1.apellidos, _this.formulario1.identity.number).then(function (res) {
          if (!res.data.correct) {
            return callback(new Error(_this.$t('rules.lastname_rule')));
          } else {
            return callback();
          }
        }).catch(function () {
          return callback(new Error(_this.$t('rules.lastname_rule')));
        }).finally(function () {
          _this.$store.dispatch('loader/down', {
            trigger: _this.$options.name
          });
        });
      }
    };
    var check_Empresa = function check_Empresa(rule, value, callback) {
      if (!value) {
        return callback(new Error(_this.$t('rules.empresa_oferente_required')));
      } else {
        _this.$store.dispatch('loader/up', {
          trigger: _this.$options.name
        });
        var suggest = _this.suggest;
        var results = suggest.filter(function (empresa) {
          return empresa.value.toLowerCase() == value.toLowerCase();
        });
        _this.$store.dispatch('loader/down', {
          trigger: _this.$options.name
        });
        if (results.length == 0) {
          //  this.formulario1.empresa_oferante = '';
          return callback(new Error(_this.$t('rules.empresa_oferente_invalido')));
        }
        return callback();
      }
    };
    return {
      reference: 'formulario1',
      sucursales: [],
      relacion_laboral: [],
      empresas_oferentes: [],
      suggest: [],
      formulario1: {
        nombres: '',
        apellidos: '',
        telefono: '',
        fecha_nacimiento: '',
        identity: {
          document: 1
        },
        type_prestamo: '',
        consulta_clearing: 0,
        consulta_bcu: 0,
        fecha_ingreso: '',
        relacion_laboral_id: '',
        tipo_vehiculo: '',
        empresa_oferante: ''
      },
      view_sucursal: false,
      rules_formulario1: {
        'identity.document': [required('')],
        'identity.number': [required(''), EspacioBlanco()],
        nombres: [{
          validator: check_name,
          trigger: 'blur'
        }],
        apellidos: [{
          validator: check_lastname,
          trigger: 'blur'
        }],
        telefono: [{
          validator: check_telefono,
          trigger: 'blur'
        }],
        fecha_nacimiento: [required('')],
        fecha_ingreso: [{
          validator: check_Fecha,
          trigger: 'blur'
        }],
        relacion_laboral_id: [required('')],
        tipo_vehiculo: [required('')],
        empresa_oferante: [{
          validator: check_Empresa,
          trigger: 'change'
        }]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return Date.now() < time.getTime();
        }
      }
    };
  },
  computed: {
    isjubilado: function isjubilado() {
      return this.formulario1.relacion_laboral_id && this.formulario1.relacion_laboral_id == '4';
    },
    condocumento: function condocumento() {
      var docmun = localStorage.getItem('docnum');
      if (docmun) {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    var _this2 = this;
    this.$store.dispatch('loader/up', {
      trigger: this.$options.name
    });
    var docmun = localStorage.getItem('docnum');
    if (docmun) this.formulario1.identity.number = docmun;
    var re = getRelacionesLaborales().then(function (res) {
      _this2.relacion_laboral = res.data;
    }).catch(function () {
      _this2.relacion_laboral = [];
    });
    var emp = getEmpresasOferentes().then(function (res) {
      _this2.empresas_oferentes = res.data;
    }).catch(function () {
      _this2.empresas_oferentes = [];
    });
    Promise.all([re, emp]).then(function () {
      _this2.suggest = Object.values(_this2.empresas_oferentes).map(function (value) {
        return {
          value: value
        };
      });
    }).finally(function () {
      _this2.$store.dispatch('loader/down', {
        trigger: _this2.$options.name
      });
    });
  },
  methods: {
    getSuggest: function getSuggest(queryString, cb) {
      var suggest = this.suggest;
      var self = this;
      var results = !isEmpty(queryString) && !isEmpty(suggest) ? suggest.filter(function (value) {
        return self._.deburr(value.value).toLowerCase().indexOf(self._.deburr(queryString).toLowerCase()) >= 0;
      }) : suggest;
      cb(results);
    }
  }
};